export const TIMEZONE_OPTIONS = [
  {
    label: "Atlantic (UTC-04:00) - DST: +60 minutes",
    value: "America/Halifax",
    utcOffset: "-04:00",
    dstAdjustmentMinutes: 60,
  },
  {
    label: "Eastern (UTC-05:00) - DST: +60 minutes",
    value: "America/New_York",
    utcOffset: "-05:00",
    dstAdjustmentMinutes: 60,
  },
  {
    label: "Central (UTC-06:00) - DST: +60 minutes",
    value: "America/Chicago",
    utcOffset: "-06:00",
    dstAdjustmentMinutes: 60,
  },
  {
    label: "Mountain (UTC-07:00) - DST: +60 minutes",
    value: "America/Denver",
    utcOffset: "-07:00",
    dstAdjustmentMinutes: 60,
  },
  {
    label: "Arizona (UTC-07:00) - DST: +0 minutes",
    value: "America/Phoenix",
    utcOffset: "-07:00",
    dstAdjustmentMinutes: 0,
  },
  {
    label: "Pacific (UTC-08:00) - DST: +60 minutes",
    value: "America/Los_Angeles",
    utcOffset: "-08:00",
    dstAdjustmentMinutes: 60,
  },
  {
    label: "Alaska (UTC-09:00) - DST: +60 minutes",
    value: "America/Anchorage",
    utcOffset: "-09:00",
    dstAdjustmentMinutes: 60,
  },
  {
    label: "Hawaii (UTC-10:00) - DST: +0 minutes",
    value: "Pacific/Honolulu",
    utcOffset: "-10:00",
    dstAdjustmentMinutes: 0,
  },
  {
    label: "Samoa (UTC-11:00) - DST: +0 minutes",
    value: "Pacific/Pago_Pago",
    utcOffset: "-11:00",
    dstAdjustmentMinutes: 0,
  },
  {
    label: "Guam/Chamorro (UTC+10:00) - DST: +0 minutes",
    value: "Pacific/Guam",
    utcOffset: "+10:00",
    dstAdjustmentMinutes: 0,
  },
];
